import { createClient } from "@supabase/supabase-js";

// Valores de conexão — anon key é pública (publishable), segura para client-side.
const SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ??
  "https://uucputelxaotbcnmzrwm.supabase.co";

const SUPABASE_ANON_KEY =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ??
  "sb_publishable_0S-rSMhH68vFoqs_NStrJQ_GZclbUdA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // localStorage: persiste entre sessões do navegador, ideal para PWA/App Desktop.
    persistSession: true,
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type AppRole = "admin" | "user";
